import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'tamagui'
import format from 'date-fns/format'

const SECOND = 1000
const HOUR = 60 * 60 * SECOND

const pad = (value: number) => String(value).padStart(2, '0')

// Prazo do Pix gerado no painel. O Pix vale 24 h (o mesmo do checkout): mostra até quando, e na
// última hora vira contagem regressiva.
export function PixExpiry({ expiresAt }: { expiresAt: Date }) {
  const { t } = useTranslation('DirectPurchase')
  const [now, setNow] = useState(() => Date.now())
  const remaining = Math.max(expiresAt.getTime() - now, 0)
  const counting = remaining <= HOUR
  // Fora da última hora atualiza de minuto em minuto, mas acorda na hora exata de começar a contar.
  const delay = counting
    ? SECOND
    : Math.max(Math.min(60 * SECOND, remaining - HOUR), SECOND)

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), delay)
    return () => clearInterval(id)
  }, [delay])

  const label = !remaining
    ? t('pixExpiredShort')
    : counting
      ? t('pixExpiresIn', {
          time: `${pad(Math.floor(remaining / 60000))}:${pad(Math.floor((remaining % 60000) / SECOND))}`,
        })
      : t('pixValidUntil', { date: format(expiresAt, "dd/MM 'às' HH:mm") })

  return (
    <Text
      color="$neutral-800"
      fontFamily="$mulishRegular"
      fontSize="$font-size-xxs"
      testID="pix-expiry"
      textAlign="center"
    >
      {label}
    </Text>
  )
}
